const elements = [
  { icon: 'ri-search-line', title: 'Диагностика', desc: 'Аудит текущих компетенций, KPI и бизнес-процессов. Без диагностики программа строится на предположениях, а не на данных.' },
  { icon: 'ri-focus-3-line', title: 'Цели', desc: 'Чёткие, измеримые цели программы, привязанные к бизнес-показателям. Не «улучшить переговоры», а «поднять конверсию на 15%».' },
  { icon: 'ri-stack-line', title: 'Компетенции', desc: 'Модель компетенций для каждой целевой группы. Какие навыки развиваем, до какого уровня, в какой последовательности.' },
  { icon: 'ri-tools-line', title: 'Практика (80%)', desc: 'Основное время программы — отработка на реальных кейсах. Ролевые игры, бизнес-симуляции, проектная работа над задачами компании.' },
  { icon: 'ri-file-text-line', title: 'Домашние задания', desc: 'Межмодульные задания, которые участники выполняют на рабочем месте. Применяют новые инструменты в реальных условиях.' },
  { icon: 'ri-chat-check-line', title: 'Обратная связь', desc: 'Регулярная обратная связь участникам: письменная и устная. Руководители вовлечены в процесс и дают обратную связь на рабочем месте.' },
  { icon: 'ri-bar-chart-box-line', title: 'Измерение результатов', desc: 'Замеры KPI до, сразу после и через 2-3 месяца. Отчёт для руководства с конкретными цифрами и динамикой показателей.' },
  { icon: 'ri-rocket-2-line', title: 'Внедрение', desc: 'План внедрения новых навыков в работу. Поддержка руководителей, корректировка процессов при необходимости.' },
  { icon: 'ri-user-heart-line', title: 'Поддержка', desc: 'Сопровождение на 2-3 месяца после программы. Чек-поинты, ответы на вопросы, помощь в сложных ситуациях.' },
];

export default function GoodProgramStructure() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Из чего состоит хорошая корпоративная программа
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Девять обязательных элементов, без которых программа обучения не даст устойчивого результата
        </p>

        <div className="relative">
          {elements.map((el, i) => (
            <div key={i} className="flex items-start gap-5 mb-8 last:mb-0">
              <div className="flex flex-col items-center">
                <div className="w-14 h-14 bg-teal-600 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-md z-10">
                  <i className={`${el.icon} text-xl text-white`}></i>
                </div>
                {i < elements.length - 1 && (
                  <div className="w-1 flex-1 bg-teal-200 my-2 min-h-[30px]"></div>
                )}
              </div>
              <div className="flex-1 pt-3">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{el.title}</h3>
                <p className="text-gray-600 leading-relaxed">{el.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}